import axiosInstance from "../../../config/axios";

export const getAccountReceivablesList = async (customerId: string, params: any) => {
    const response = await axiosInstance.get(`/sales/accountReceivablesList/${customerId}`,{
        params,
        headers: {
            'customer': customerId
        }
    });
    return response.data;
}

// Fetch the live outstanding balance for a customer (used by the Navbar
// "Outstanding balance" chip for both retailer and sales roles).
export const getCustomerBalance = async (customerId: string | number) => {
    const response = await axiosInstance.get(`/sales/customerBalance/${customerId}`);
    return response.data;
}